import React from "react";
import axios from "axios";
import { API_URL } from "../../services/api";

const headers = (token) => {
    return {
        headers: {
            Authorization: `Bearer ${token.token}`,
        },
    };
};

const export_db = (slug, token) => {
    // axios.get(API_URL + "form/export-db/" + slug, headers(token));
    window.open(`/form/export-db/${slug}`, "_blank");
    // .then((response) => {
    //     console.log(response);
    // })
    // .catch((error) => {
    //     console.log(error);
    // });
};

export default export_db;
